import { render } from "./HiButton.vue?vue&type=template&id=ea458172"
import script from "./HiButton.vue?vue&type=script&lang=js"
export * from "./HiButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__